import React from 'react';
import { Reveal } from './Reveal';
type Testimonial = {
  initials: string;
  quote: string;
  name: string;
  role: string;
};
const testimonials: Testimonial[] = [{
  initials: 'SR',
  quote: 'I have been reading Tarot for 6 years and always felt something was missing. Volume 1 alone gave me more structured reference knowledge than three courses I paid hundreds for. The upright and reversed meanings with astrological correspondences changed everything.',
  name: 'Sarah R.',
  role: 'Los Angeles, CA · Tarot Practitioner'
}, {
  initials: 'JM',
  quote: 'As a Reiki practitioner I needed a permanent reference I could trust during sessions. The Reiki Decoded volume is the most complete guide I have ever seen. The hand position guides and chakra integration maps are exactly what I needed to work with real confidence.',
  name: 'James M.',
  role: 'London, UK · Reiki Healer & Coach'
}, {
  initials: 'ML',
  quote: 'The Crystals Decoded bonus alone was worth ten times the price. Having 200+ crystals in one organized reference with chakra and elemental correspondences saved me hours of searching every week. I have the chart printed and laminated in my therapy room.',
  name: 'Maria L.',
  role: 'Sydney, Australia · Holistic Therapist'
}];
export function TestimonialStrip() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-220" data-mp="1vfiaeldyitme">
      <div className="mx-auto max-w-6xl" data-id="element-221" data-mp="1vdxjr6urjutt">
        <Reveal className="text-center" data-id="element-222" data-mp="296ngo6btyk5p">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-223" data-mp="295ltj3hji77m">
            ⭐ What Practitioners Are <span className="text-sage" data-id="element-224" data-mp="255k0tjts8o4h">Saying</span>
          </h2>
          <p className="mt-4 text-slate" data-id="element-225" data-mp="2j4joop9h0yzl">
            People who finally have the professional system their practice deserved.
          </p>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-226" data-mp="2e4ouocueftab">
          {testimonials.map((item, index) => <Reveal key={item.initials} delay={index * 0.05} data-id="element-227" data-mp="oteoxw1i96pj" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-navy/10 bg-surface p-8 shadow-premium" data-id="element-228" data-mp="jts9dfy7fedk">
                <div className="text-amber" data-id="element-229" data-mp="2jwkw85vxnf3o">★★★★★</div>
                <blockquote className="mt-5 flex-1 text-[15px] leading-7 text-slate" data-id="element-230" data-mp="2ot1isvnhhlen">
                  “{item.quote}”
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-3" data-id="element-231" data-mp="2sxj1eri3xsnu">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-sage/15 text-sm font-bold text-sage" data-id="element-232" data-mp="2xvaptbjjmwna">
                    {item.initials}
                  </span>
                  <span data-id="element-233" data-mp="37re3nenrcjq2">
                    <span className="block font-bold text-navy" data-id="element-234" data-mp="37quna2dra3e5">{item.name}</span>
                    <span className="mt-0.5 block text-xs text-slate" data-id="element-235" data-mp="3cjxguaij9cuc">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}